module.exports = __webpack_public_path__ + "static/img/coupon-player.68dbee94.png";